import { ContentBlock } from '../components'

const Delivered = () => (
  <ContentBlock title="Your order was delivered!">
    We hope you enjoy your new breast pump!
  </ContentBlock>
)

export default Delivered
